<template>
  <div class="mcontainer">
    <div class="breadcrumb-area py-0">
      <div class="breadcrumb">
        <ul class="m-0">
          <li><router-link to="/app/admin/news">Kelola News</router-link></li>
          <li class="active"><a href="#">Master Kategori News</a></li>
        </ul>
      </div>
    </div>
    <div class="max-w-3xl m-auto shadow-md rounded-md bg-white mt-5">
      <div class="border-b p-4 flex justify-between items-center">
        <h3 class="font-bold text-lg">Master Kategori News</h3>
        <button type="button" class="btn btn-primary" @click="openAdd">
          <Icon icon="mdi:plus" width="18" height="18" />
          Tambah Kategori
        </button>
      </div>
      <div class="p-6">
        <div v-if="loading" class="text-center py-8"><b-spinner /> Loading...</div>
        <div v-else-if="list.length === 0" class="text-center py-8 text-gray-500">
          Belum ada kategori. Klik "Tambah Kategori" untuk menambah.
        </div>
        <table v-else class="w-full">
          <thead>
            <tr class="border-b">
              <th class="text-left py-2 font-semibold">No</th>
              <th class="text-left py-2 font-semibold">Nama Kategori</th>
              <th class="text-right py-2 font-semibold">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in list" :key="item.id" class="border-b border-gray-100">
              <td class="py-3">{{ idx + 1 }}</td>
              <td class="py-3">{{ item.title }}</td>
              <td class="py-3 text-right">
                <button type="button" class="action-btn action-edit mr-2" @click="openEdit(item)">Edit</button>
                <button type="button" class="action-btn action-delete" @click="confirmDelete(item)">Hapus</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal v-model="modalShow" :title="modalTitle" @hide="resetForm">
      <div class="p-2">
        <label class="font-semibold block mb-2">Nama Kategori</label>
        <input v-model="form.title" type="text" class="form-control" placeholder="Contoh: Prestasi, Kegiatan">
      </div>
      <template #modal-footer>
        <button type="button" class="btn btn-secondary" @click="modalShow = false">Batal</button>
        <button type="button" class="btn btn-primary" :disabled="submitting" @click="submit">
          <b-spinner v-if="submitting" small />
          <span v-else>{{ form.id ? 'Update' : 'Simpan' }}</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { Icon } from '@iconify/vue2'

export default {
  name: 'NewsCategoryAdmin',
  components: { Icon },
  data () {
    return {
      list: [],
      loading: true,
      modalShow: false,
      modalTitle: 'Tambah Kategori',
      form: { id: null, title: '' },
      submitting: false
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await axios.get('category?type=news')
        this.list = res.data.result || []
      } catch (e) {
        this.$swal({ icon: 'error', title: 'Error', text: e.response?.data?.message || 'Gagal memuat data' })
      } finally {
        this.loading = false
      }
    },
    openAdd () {
      this.modalTitle = 'Tambah Kategori'
      this.form = { id: null, title: '' }
      this.modalShow = true
    },
    openEdit (item) {
      this.modalTitle = 'Edit Kategori'
      this.form = { id: item.id, title: item.title }
      this.modalShow = true
    },
    resetForm () {
      this.form = { id: null, title: '' }
    },
    async submit () {
      if (!this.form.title.trim()) {
        this.$swal({ icon: 'warning', title: 'Perhatian', text: 'Nama kategori wajib diisi' })
        return
      }
      this.submitting = true
      try {
        if (this.form.id) {
          await axios.post(`category/${this.form.id}`, { title: this.form.title, type: 'news' })
          this.$swal({ icon: 'success', title: 'Berhasil', text: 'Kategori berhasil diupdate' })
        } else {
          await axios.post('category', { title: this.form.title, type: 'news' })
          this.$swal({ icon: 'success', title: 'Berhasil', text: 'Kategori berhasil ditambahkan' })
        }
        this.modalShow = false
        this.fetchList()
      } catch (e) {
        this.$swal({ icon: 'error', title: 'Error', text: e.response?.data?.message || 'Gagal menyimpan' })
      } finally {
        this.submitting = false
      }
    },
    confirmDelete (item) {
      this.$swal({
        title: 'Yakin hapus?',
        text: `Kategori "${item.title}" akan dihapus`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, hapus'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteItem(item.id)
        }
      })
    },
    async deleteItem (id) {
      try {
        await axios.delete(`category/${id}`)
        this.$swal({ icon: 'success', title: 'Berhasil', text: 'Kategori berhasil dihapus' })
        this.fetchList()
      } catch (e) {
        this.$swal({ icon: 'error', title: 'Error', text: e.response?.data?.message || 'Gagal menghapus' })
      }
    }
  }
}
</script>

<style scoped>
.form-control { width: 100%; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 8px; }
.btn { padding: 8px 16px; border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; }
.btn-primary { background: #3b82f6; color: #fff; border: none; cursor: pointer; }
.btn-secondary { background: #e5e7eb; color: #374151; }
.action-btn { padding: 4px 12px; border-radius: 6px; font-size: 13px; cursor: pointer; border: none; }
.action-edit { background: #dbeafe; color: #1d4ed8; }
.action-delete { background: #fee2e2; color: #b91c1c; }
</style>
